import React from 'react';
import PropTypes from 'prop-types';
import ViewsMenu from '../../../CatalogBody/ViewsMenu';

const ViewSelector = (props) => <ViewsMenu mode="dropdown" {...props} />;

ViewSelector.propTypes = {
  sceneId: PropTypes.string.isRequired,
  viewId: PropTypes.string,
  catalog: PropTypes.object,
  className: PropTypes.string,
};

export default ViewSelector;
